
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import closeIcon from '@/assets/images/close.png'
import { Prop } from 'vue-property-decorator'
@Component({ name: 'vBottonPop' })
export default class IndexView extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  title!: string
  closeIcon = closeIcon
  @Prop({
    type: Boolean,
    default: false,
  })
  tipShow!: boolean
  @Prop({
    type: Boolean,
    default: true,
  })
  isShowClose!: boolean
  @Prop({
    type: Boolean,
    default: false,
  })
  clickOverlay!: boolean
  @Prop({ type: Boolean, default: false }) fixed!: boolean

  showSheet = false

  @Watch('tipShow', { immediate: true })
  handleResultShowWatch(val: boolean) {
    if (val !== this.showSheet) {
      this.showSheet = val
    }
  }

  closePop() {
    this.$emit('closeTip')
  }
}
